import Swal from 'sweetalert2'

export function useInfo(message, title = 'ATENÇÃO!') {
	return Swal.fire({
		icon: 'info',
		title,
		customClass: {
			container: 'themed',
		},
		html: message,
	})
}
